/**
 * Real authentication mode. Used by the production build and by `npm run start:auth`.
 * Login is required, identity and role come from GET /api/v1/me, and the development role switcher does not exist.
 */
export const environment = {
  requireAuth: true,
  devRoleSwitcher: false,
};
